"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _mobx = require("mobx");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _humanTime = _interopRequireDefault(require("human-time"));
var _root_model = _interopRequireDefault(require("./root_model"));
var _word_association = _interopRequireDefault(require("./word_association"));
var _target = _interopRequireDefault(require("./target"));
var _level = _interopRequireDefault(require("./level"));
var _page = _interopRequireDefault(require("./page"));
var _user = _interopRequireDefault(require("./user"));
var _word = _interopRequireDefault(require("./word"));
var _video_clip = _interopRequireDefault(require("./video_clip"));
var _sentence_state = _interopRequireDefault(require("./sentence_state"));
var _date_decorator = _interopRequireDefault(require("./date_decorator"));
var _image = _interopRequireDefault(require("./image"));
var _translation_source = _interopRequireDefault(require("./translation_source"));
var _multiple_choice_option = _interopRequireDefault(require("./multiple_choice_option"));
var _sentence_basic = _interopRequireDefault(require("./sentence_basic"));
var _constants = require("@seedlang/constants");
var _src = require("@seedlang/utils/src");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _descriptor64, _descriptor65, _descriptor66, _descriptor67; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
// also SentenceBasic
var Sentence = (_dec = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec2 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_word_association["default"]))), _dec3 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_translation_source["default"]))), _dec4 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_multiple_choice_option["default"]))), _dec5 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_sentence_basic["default"]))), _dec6 = (0, _serializr.serializable)((0, _serializr.object)(_video_clip["default"])), _dec7 = (0, _serializr.serializable)((0, _serializr.object)(_video_clip["default"])), _dec8 = (0, _serializr.serializable)((0, _serializr.object)(_video_clip["default"])), _dec9 = (0, _serializr.serializable)((0, _serializr.object)(_image["default"])), _dec10 = (0, _serializr.serializable)((0, _serializr.object)(_level["default"])), _dec11 = (0, _serializr.serializable)((0, _serializr.object)(_page["default"])), _dec12 = (0, _serializr.serializable)((0, _serializr.object)(_target["default"])), _dec13 = (0, _serializr.serializable)((0, _serializr.object)(_sentence_basic["default"])), _dec14 = (0, _serializr.serializable)((0, _serializr.object)(_user["default"])), _dec15 = (0, _serializr.serializable)((0, _serializr.object)(_user["default"])), _dec16 = (0, _serializr.serializable)((0, _serializr.object)(_user["default"])), _dec17 = (0, _serializr.serializable)((0, _serializr.object)(_user["default"])), _class = /*#__PURE__*/function (_RootModel) {
  function Sentence(obj) {
    var _this;
    _classCallCheck(this, Sentence);
    _this = _callSuper(this, Sentence, [obj]);
    _initializerDefineProperty(_this, "enrichedWords", _descriptor, _this);
    _initializerDefineProperty(_this, "correctVideoUploading", _descriptor2, _this);
    _initializerDefineProperty(_this, "incorrectVideoUploading", _descriptor3, _this);
    _initializerDefineProperty(_this, "originalDeckId", _descriptor4, _this);
    _initializerDefineProperty(_this, "selectedDeckId", _descriptor5, _this);
    _initializerDefineProperty(_this, "id", _descriptor6, _this);
    _initializerDefineProperty(_this, "levelId", _descriptor7, _this);
    _initializerDefineProperty(_this, "literalSource", _descriptor8, _this);
    _initializerDefineProperty(_this, "literalSourceUk", _descriptor9, _this);
    _initializerDefineProperty(_this, "validSetup", _descriptor10, _this);
    _initializerDefineProperty(_this, "reviewed1", _descriptor11, _this);
    _initializerDefineProperty(_this, "reviewed2", _descriptor12, _this);
    _initializerDefineProperty(_this, "reviewed3", _descriptor13, _this);
    _initializerDefineProperty(_this, "note", _descriptor14, _this);
    _initializerDefineProperty(_this, "public", _descriptor15, _this);
    _initializerDefineProperty(_this, "timestamp", _descriptor16, _this);
    _initializerDefineProperty(_this, "position", _descriptor17, _this);
    _initializerDefineProperty(_this, "supplement", _descriptor18, _this);
    _initializerDefineProperty(_this, "isQuestion", _descriptor19, _this);
    _initializerDefineProperty(_this, "interjectionId", _descriptor20, _this);
    _initializerDefineProperty(_this, "hasAllVideoClips", _descriptor21, _this);
    _initializerDefineProperty(_this, "targetText", _descriptor22, _this);
    _initializerDefineProperty(_this, "sentenceConceptId", _descriptor23, _this);
    _initializerDefineProperty(_this, "answersCount", _descriptor24, _this);
    _initializerDefineProperty(_this, "simple", _descriptor25, _this);
    _initializerDefineProperty(_this, "useInFeedEntry", _descriptor26, _this);
    _initializerDefineProperty(_this, "commentsCount", _descriptor27, _this);
    _initializerDefineProperty(_this, "forumThreadId", _descriptor28, _this);
    _initializerDefineProperty(_this, "questionId", _descriptor29, _this);
    _initializerDefineProperty(_this, "excludeFromPublicLists", _descriptor30, _this);
    _initializerDefineProperty(_this, "levelAbbreviation", _descriptor31, _this);
    _initializerDefineProperty(_this, "tag", _descriptor32, _this);
    _initializerDefineProperty(_this, "isTriviaSentence", _descriptor33, _this);
    _initializerDefineProperty(_this, "hasDeck", _descriptor34, _this);
    _initializerDefineProperty(_this, "hasExternalContent", _descriptor35, _this);
    _initializerDefineProperty(_this, "validatedWithSmarty", _descriptor36, _this);
    _initializerDefineProperty(_this, "attemptedValidationWithSmarty", _descriptor37, _this);
    _initializerDefineProperty(_this, "tokenisation", _descriptor38, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor39, _this);
    _initializerDefineProperty(_this, "showOnDevice", _descriptor40, _this);
    _initializerDefineProperty(_this, "timesShown", _descriptor41, _this);
    _initializerDefineProperty(_this, "timesClicked", _descriptor42, _this);
    _initializerDefineProperty(_this, "conjugationTenseId", _descriptor43, _this);
    _initializerDefineProperty(_this, "conjugationPronoun", _descriptor44, _this);
    _initializerDefineProperty(_this, "isTriadSentence", _descriptor45, _this);
    _initializerDefineProperty(_this, "sourcesCount", _descriptor46, _this);
    _initializerDefineProperty(_this, "sentenceSubmissionsCount", _descriptor47, _this);
    _initializerDefineProperty(_this, "speakerGender", _descriptor48, _this);
    _initializerDefineProperty(_this, "sourceLanguageIdsCount", _descriptor49, _this);
    _initializerDefineProperty(_this, "aiLanguagesTranslated", _descriptor50, _this);
    _initializerDefineProperty(_this, "createdAt", _descriptor51, _this);
    _initializerDefineProperty(_this, "wordAssociations", _descriptor52, _this);
    _initializerDefineProperty(_this, "translationSources", _descriptor53, _this);
    _initializerDefineProperty(_this, "multipleChoiceOptions", _descriptor54, _this);
    _initializerDefineProperty(_this, "answers", _descriptor55, _this);
    _initializerDefineProperty(_this, "videoClip", _descriptor56, _this);
    _initializerDefineProperty(_this, "correctVideoClip", _descriptor57, _this);
    _initializerDefineProperty(_this, "incorrectVideoClip", _descriptor58, _this);
    _initializerDefineProperty(_this, "image", _descriptor59, _this);
    _initializerDefineProperty(_this, "level", _descriptor60, _this);
    _initializerDefineProperty(_this, "page", _descriptor61, _this);
    _initializerDefineProperty(_this, "target", _descriptor62, _this);
    _initializerDefineProperty(_this, "question", _descriptor63, _this);
    _initializerDefineProperty(_this, "reviewed1User", _descriptor64, _this);
    _initializerDefineProperty(_this, "reviewed2User", _descriptor65, _this);
    _initializerDefineProperty(_this, "reviewed3User", _descriptor66, _this);
    _initializerDefineProperty(_this, "createdByUser", _descriptor67, _this);
    _this.state = new _sentence_state["default"](_this);
    (0, _mobx.autorun)(function () {
      if ((0, _utils.isPresent)(_this.wordAssociations)) {
        // this.setSelectedWordAssociation();
        _this.setEnrichedWords(_this.wordAssociations);
      }
    });
    return _this;
  }
  _inherits(Sentence, _RootModel);
  return _createClass(Sentence, [{
    key: "isAnswer",
    get: function get() {
      return (0, _utils.isPresent)(this.questionId);
    }
  }, {
    key: "defaultSource",
    get: function get() {
      if ((0, _utils.isPresent)(this.translationSources.find(function (item) {
        return item["default"];
      }))) {
        return this.translationSources.find(function (item) {
          return item["default"];
        }).source;
      }
      if ((0, _utils.isPresent)(this.translationSources.find(function (item) {
        var _item$source;
        return ((_item$source = item.source) === null || _item$source === void 0 ? void 0 : _item$source.languageId) === 'EN';
      }))) {
        return this.translationSources.find(function (item) {
          var _item$source2;
          return ((_item$source2 = item.source) === null || _item$source2 === void 0 ? void 0 : _item$source2.languageId) === 'EN';
        }).source;
      }
      if ((0, _utils.isPresent)(this.translationSources)) {
        return this.translationSources[0].source;
      }
      return null;
    }
  }, {
    key: "rightToLeftLanguage",
    get: function get() {
      return _constants.Constants.RTL_LANGUAGE_IDS.includes(this.languageId);
    }
  }, {
    key: "answer",
    get: function get() {
      return (0, _utils.isPresent)(this.answers) && (0, _utils.isPresent)(this.answers[0]) ? this.answers[0] : {};
    }
  }, {
    key: "hasImage",
    get: function get() {
      return (0, _utils.isPresent)((0, _mobx.toJS)(this.image));
    }
  }, {
    key: "hasAnswers",
    get: function get() {
      return (0, _utils.isPresent)(this.answers);
    }
  }, {
    key: "sourceText",
    get: function get() {
      return this.defaultSource ? this.defaultSource.text : null;
    }
  }, {
    key: "sourceTextForUser",
    value: function sourceTextForUser(user) {
      if ((0, _utils.isPresent)(this.translationSources.filter(function (item) {
        var _item$source3;
        return ((_item$source3 = item.source) === null || _item$source3 === void 0 ? void 0 : _item$source3.languageId) === user.languageId;
      }))) {
        return this.translationSources.filter(function (item) {
          var _item$source4;
          return ((_item$source4 = item.source) === null || _item$source4 === void 0 ? void 0 : _item$source4.languageId) === user.languageId;
        })[0].source.text;
      }
      if ((0, _utils.isPresent)(this.defaultSource)) {
        return this.defaultSource.textForUser(user);
      }
    }
  }, {
    key: "sourceTextForUserLanguageId",
    value: function sourceTextForUserLanguageId(user) {
      var _this$defaultSource;
      if ((0, _utils.isPresent)(this.translationSources.filter(function (item) {
        var _item$source5;
        return ((_item$source5 = item.source) === null || _item$source5 === void 0 ? void 0 : _item$source5.languageId) === user.languageId;
      }))) {
        return user.languageId;
      }
      return (_this$defaultSource = this.defaultSource) === null || _this$defaultSource === void 0 ? void 0 : _this$defaultSource.languageId;
    }
  }, {
    key: "randomMultipleChoiceOptions",
    get: function get() {
      return (0, _lodash.shuffle)(this.multipleChoiceOptions);
    }
  }, {
    key: "unrecordedCorrectOrIncorrect",
    get: function get() {
      return this.isAnswer && (!this.correctVideoUploading && (0, _utils.isBlank)(this.correctVideoClip) || !this.incorrectVideoUploading && (0, _utils.isBlank)(this.incorrectVideoClip));
    }
  }, {
    key: "firstUnrecordedTranslation",
    get: function get() {
      if ((0, _utils.isPresent)(this.target) && !this.target.hasVideoClipOrRecorded || this.unrecordedCorrectOrIncorrect) {
        return this;
      }
      if ((0, _utils.isPresent)(this.wordAssociations)) {
        var wordAssociation = this.wordAssociations.find(function (item) {
          return (0, _utils.isPresent)(item.word) && (0, _utils.isPresent)(item.word.target) && !item.word.target.hasVideoClipOrRecorded;
        });
        if ((0, _utils.isPresent)(wordAssociation)) {
          return wordAssociation.word;
        }
      }
    }
  }, {
    key: "firstUnrecordedTarget",
    get: function get() {
      return (0, _utils.isPresent)(this.firstUnrecordedTranslation) ? this.firstUnrecordedTranslation.target : {};
    }
  }, {
    key: "allWordAssociationsHaveValues",
    get: function get() {
      return (0, _utils.isBlank)(this.wordAssociations.find(function (item) {
        return item.selected && (0, _utils.isBlank)(item.state.submittedValue);
      }));
    }
  }, {
    key: "hasSource",
    get: function get() {
      return (0, _utils.isPresent)(this.defaultSource);
    }
  }, {
    key: "allSelectedWordsCorrect",
    get: function get() {
      return (0, _utils.isPresent)(this.wordAssociations) && (0, _lodash.every)(this.wordAssociations.map(function (item) {
        return item.selected && item.state.correct || !item.selected && !item.state.submittedValue;
      }));
    }
  }, {
    key: "allWordsCorrect",
    get: function get() {
      return (0, _utils.isPresent)(this.wordAssociations) && (0, _lodash.every)(this.wordAssociations.map(function (item) {
        return item.state.correct && item.state.hasSubmittedValue;
      }));
    }
  }, {
    key: "hasPunctuation",
    get: function get() {
      return this.targetText.match(/[.,:!?]/);
    }
  }, {
    key: "feedEntryVideoClip",
    get: function get() {
      return this.supplementVideoClip || this.targetVideoClip;
    }
  }, {
    key: "hasTargetVideoClip",
    get: function get() {
      return (0, _utils.isPresent)(this.targetVideoClip);
    }
  }, {
    key: "targetVideoClip",
    get: function get() {
      return this.target && this.target.videoClip;
    }
  }, {
    key: "hasSupplementVideoClip",
    get: function get() {
      return (0, _utils.isPresent)(this.supplementVideoClip);
    }
  }, {
    key: "supplementVideoClip",
    get: function get() {
      return this.videoClip;
    }
  }, {
    key: "hasMedia",
    get: function get() {
      return this.hasImage || this.supplementVideoClip;
    }
  }, {
    key: "hasQuestion",
    get: function get() {
      return (0, _utils.isPresent)(this.question) && (0, _utils.isPresent)(this.question.id);
    }
  }, {
    key: "pageTitle",
    get: function get() {
      return (0, _utils.isPresent)(this.page) ? this.page.title : null;
    }
  }, {
    key: "selectedWord",
    get: function get() {
      if ((0, _utils.isPresent)(this.state.selectedWordAssociation)) {
        return this.state.selectedWordAssociation.word;
      }
    }
  }, {
    key: "selectedWordAssociation",
    get: function get() {
      return this.state.selectedWordAssociation;
    }
  }, {
    key: "hasSelections",
    get: function get() {
      return (0, _utils.isPresent)(this.wordAssociations.find(function (item) {
        return item.selected;
      }));
    }
  }, {
    key: "setSelectedWordAssociation",
    value: function setSelectedWordAssociation() {
      var selectedWordAssociation = this.wordAssociations.find(function (item) {
        return item.selected;
      });
      if ((0, _utils.isPresent)(selectedWordAssociation)) {
        this.state.set('selectedWordAssociationId', selectedWordAssociation.id);
      }
    }
  }, {
    key: "selectedWordAssociations",
    get: function get() {
      return this.wordAssociations.filter(function (item) {
        return item.selected;
      });
    }
  }, {
    key: "shuffledSelectedWordAssociations",
    get: function get() {
      return (0, _lodash.shuffle)(this.selectedWordAssociations);
    }
  }, {
    key: "simpleWord",
    get: function get() {
      return this.simple && !this.targetText.match(/[.,:!?]/);
    }
  }, {
    key: "pageUrl",
    get: function get() {
      if ((0, _lodash.isEmpty)(this.page)) {
        return;
      }
      return this.timestamp ? "".concat(this.page.url, "&t=").concat(this.timestamp) : this.page.url;
    }
  }, {
    key: "findWord",
    value: function findWord(id) {
      return this.wordAssociations.find(function (item) {
        return item.word.id === id;
      });
    }
  }, {
    key: "nextInterval",
    value: function nextInterval(score) {
      if ((0, _utils.isPresent)(this.nextReviews)) {
        var time = this.nextReviews[String(score)];
        return "Review ".concat((0, _humanTime["default"])(time * -1));
      }
      return null;
    }
  }, {
    key: "targetTextWithPrefix",
    value: function targetTextWithPrefix(word) {
      if (word.hasPrefix) {
        return word.targetTextWithPrefix;
      }
      if (word.rootWordId && word.isPrefix) {
        var prefixWordAssociation = this.wordAssociations.find(function (item) {
          return item.word.isStem && item.word.rootWordId === word.rootWordId;
        });
        if ((0, _utils.isPresent)(prefixWordAssociation)) {
          return "".concat(word.targetText, "...").concat(prefixWordAssociation.word.targetText);
        }
      } else if (word) {
        return word.targetTextWithDefiniteArticle;
      }
    }
  }, {
    key: "targetTextWithDefiniteArticle",
    get: function get() {
      return this.targetText; // ducktyping with word.js
    }
  }, {
    key: "selectedWordAssociationPositions",
    get: function get() {
      return this.selectedWordAssociations.map(function (item) {
        return item.position;
      });
    }
  }, {
    key: "selectedWordAssociationTargetTexts",
    get: function get() {
      return this.selectedWordAssociations.map(function (item) {
        return item.targetText;
      });
    }
  }, {
    key: "setOriginalDeckId",
    value: function setOriginalDeckId(originalDeckId) {
      this.originalDeckId = originalDeckId;
    }
  }, {
    key: "setSelectedDeckId",
    value: function setSelectedDeckId(selectedDeckId) {
      this.selectedDeckId = selectedDeckId;
    }
  }, {
    key: "clearDeckIds",
    value: function clearDeckIds() {
      this.originalDeckId = null;
      this.selectedDeckId = null;
    }
  }, {
    key: "setEnrichedWords",
    value: function setEnrichedWords(wordAssociations) {
      this.enrichedWords = wordAssociations.map(function (item) {
        var word = _objectSpread({}, (0, _mobx.toJS)(item.word));
        word.wordAssociationId = item.id;
        word.source = item.source;
        word.concepts = (0, _lodash.concat)((0, _mobx.toJS)(word.concepts), (0, _mobx.toJS)(item.concepts));
        return new _word["default"](word);
      });
    }
  }, {
    key: "translationFromTarget",
    value: function translationFromTarget(targetId) {
      if (this.target.id === targetId) {
        return this;
      }
      var words = this.wordAssociations.map(function (item) {
        return item.word;
      });
      return words.find(function (item) {
        return item.target.id === targetId;
      });
    }
  }, {
    key: "literalSourceForUser",
    value: function literalSourceForUser(user) {
      return user !== null && user !== void 0 && user.useBritishEnglish && this.literalSourceUk ? this.literalSourceUk : this.literalSource;
    }
  }, {
    key: "displayTargetText",
    get: function get() {
      return (0, _src.displayTargetTextCorrectedForLanguage)(this.targetText, this.languageId);
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "enrichedWords", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "correctVideoUploading", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "incorrectVideoUploading", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "originalDeckId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "selectedDeckId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "levelId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "literalSource", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "literalSourceUk", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "validSetup", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "reviewed1", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "reviewed2", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "reviewed3", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "note", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "public", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "timestamp", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "position", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "supplement", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "isQuestion", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "interjectionId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "hasAllVideoClips", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "targetText", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "sentenceConceptId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "answersCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "simple", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "useInFeedEntry", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "commentsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "forumThreadId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "questionId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "excludeFromPublicLists", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "levelAbbreviation", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "tag", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "isTriviaSentence", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "hasDeck", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "hasExternalContent", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "validatedWithSmarty", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "attemptedValidationWithSmarty", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "tokenisation", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "showOnDevice", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "timesShown", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "timesClicked", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "conjugationTenseId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "conjugationPronoun", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "isTriadSentence", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "sourcesCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "sentenceSubmissionsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "speakerGender", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "sourceLanguageIdsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "aiLanguagesTranslated", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "wordAssociations", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "translationSources", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "multipleChoiceOptions", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "answers", [_mobx.observable, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "videoClip", [_mobx.observable, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "correctVideoClip", [_mobx.observable, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "incorrectVideoClip", [_mobx.observable, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor59 = _applyDecoratedDescriptor(_class.prototype, "image", [_mobx.observable, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor60 = _applyDecoratedDescriptor(_class.prototype, "level", [_mobx.observable, _dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor61 = _applyDecoratedDescriptor(_class.prototype, "page", [_mobx.observable, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor62 = _applyDecoratedDescriptor(_class.prototype, "target", [_mobx.observable, _dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor63 = _applyDecoratedDescriptor(_class.prototype, "question", [_mobx.observable, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor64 = _applyDecoratedDescriptor(_class.prototype, "reviewed1User", [_mobx.observable, _dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor65 = _applyDecoratedDescriptor(_class.prototype, "reviewed2User", [_mobx.observable, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor66 = _applyDecoratedDescriptor(_class.prototype, "reviewed3User", [_mobx.observable, _dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor67 = _applyDecoratedDescriptor(_class.prototype, "createdByUser", [_mobx.observable, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "isAnswer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAnswer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultSource", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultSource"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rightToLeftLanguage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rightToLeftLanguage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "answer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "answer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasImage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasAnswers", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasAnswers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sourceText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sourceText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sourceTextForUser", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "sourceTextForUser"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "randomMultipleChoiceOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "randomMultipleChoiceOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unrecordedCorrectOrIncorrect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "unrecordedCorrectOrIncorrect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstUnrecordedTranslation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstUnrecordedTranslation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstUnrecordedTarget", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstUnrecordedTarget"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allWordAssociationsHaveValues", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allWordAssociationsHaveValues"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasSource", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasSource"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allSelectedWordsCorrect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allSelectedWordsCorrect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allWordsCorrect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allWordsCorrect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasPunctuation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasPunctuation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "feedEntryVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "feedEntryVideoClip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasTargetVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasTargetVideoClip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetVideoClip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasSupplementVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasSupplementVideoClip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "supplementVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "supplementVideoClip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasMedia", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasMedia"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasQuestion", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasQuestion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pageTitle", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pageTitle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWord", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWord"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWordAssociation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWordAssociation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasSelections", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasSelections"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSelectedWordAssociation", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedWordAssociation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWordAssociations", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWordAssociations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shuffledSelectedWordAssociations", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "shuffledSelectedWordAssociations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "simpleWord", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "simpleWord"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pageUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pageUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "findWord", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "findWord"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetTextWithDefiniteArticle", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetTextWithDefiniteArticle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWordAssociationPositions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWordAssociationPositions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWordAssociationTargetTexts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWordAssociationTargetTexts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayTargetText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayTargetText"), _class.prototype), _class);
var _default = exports["default"] = Sentence;